import { useModals } from '@frontend/modal';

import { useAppDispatch } from '../../../redux/store';

export const useGates = () => {
    const { openModal, closeModal } = useModals();
    const dispatch = useAppDispatch();
    const openGateModalId = 'open-gate-modal';
    const closeGateModalId = 'close-gate-modal';

    return {
        dispatch,
        openModal,
        closeModal,
        openGateModalId,
        closeGateModalId
    };
};
